import { Components, CssVarsTheme, Theme } from "@mui/material";

const Link = (
  theme: Theme
): Components<Omit<Theme, "components" | "palette"> & CssVarsTheme> => ({
  MuiLink: {
    styleOverrides: {
      root: {
        color: theme.palette.primary.main,
        textDecoration: "none",
      },
    },
  },
});

export default Link;
